"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg24CallCustomer = function Svg24CallCustomer(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.044 12.081C-.054 10.893.92 10 2 10h2.2a2 2 0 0 1 1.951 1.562l.43 1.91a2 2 0 0 1-1.004 2.2L3.61 16.73a11.062 11.062 0 0 0 3.66 3.66l1.06-1.968a2 2 0 0 1 2.2-1.003l1.91.429A2 2 0 0 1 14 19.8V22c0 1.08-.893 2.054-2.081 1.956a12.926 12.926 0 0 1-4.693-1.306 13.05 13.05 0 0 1-5.876-5.876 12.924 12.924 0 0 1-1.306-4.693z",
    fill: useDefaultColors ? '#191919' : fill
  }), _react.default.createElement("path", {
    d: "M7.72 5.464A2 2 0 0 0 9 9v4a2 2 0 0 0 2 2h2v-5a2 2 0 0 1 4 0v5h2a2 2 0 0 0 2-2V9a2 2 0 0 0 1.28-3.536L16.774.875c-.072-.06-.195-.163-.318-.25a2.5 2.5 0 0 0-.77-.378 2.5 2.5 0 0 0-1.372 0 2.5 2.5 0 0 0-.77.378 5.53 5.53 0 0 0-.319.25L7.72 5.464z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg24CallCustomer.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg24CallCustomer;
exports.default = _default;